export function getPathsFromObject(obj: any, path = '', paths: string[] = []): string[] {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            const currentPath = path ? `${path}.${key}` : key;
            if (Array.isArray(value)) {
                value.forEach((item, index) => {
                    const itemPath = `${currentPath}[${index}]`;
                    if (typeof item === 'object' && (item !== null)) {
                        getPathsFromObject(item, itemPath, paths);
                    } else {
                        paths.push(itemPath);
                    }
                });
            } else if (typeof value === 'object' && (value !== null)) {
                getPathsFromObject(value, currentPath, paths);
            } else {
                paths.push(currentPath);
            }
        }
    }
    return paths;
}

export function setLeafNodesToValue(obj: any, value: any) {
    if (Array.isArray(obj)) {
        obj.forEach((item) => {
            if (typeof obj === 'object') {
                setLeafNodesToValue(item, value);
            }
        });
    } else if (typeof obj === 'object') {
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const prop = obj[key];
                if (typeof prop === 'object') {
                    setLeafNodesToValue(prop, value);
                } else {
                    obj[key] = value;
                }
            }
        }
    }
}

// eslint-disable-next-line complexity
export function bBelongToA(a, b) {
    if (typeof a !== 'object' || typeof b !== 'object') {
        return a === b;
    }
    if (a === null || b === null) {
        return a === b;
    }
    if (Array.isArray(b) && b.length === 0) {
        if (!Array.isArray(a) || a.length !== 0) {
            // b为空数组,a不是
            return false;
        }
    }
    if (Array.isArray(a) && Array.isArray(b) && a.length !== b.length) {
        // a b 均为数组，但长度不一样
        return false;
    }
    for (const key in b) {
        if (key in a) {
            if (typeof a[key] === 'object' && typeof b[key] === 'object') {
                if (!bBelongToA(a[key], b[key])) {
                    return false;
                }
            } else if (a[key] !== b[key]) {
                const isSame = b[key] === null && a[key] === undefined;
                if (!isSame) {
                    return false;
                }
            }
        } else if ((b[key] !== null) && (b[key] !== undefined)) {
            return false;
        }
    }
    return true;
}

/**
 * 对比对象a和b，剔除b中与a一致的属性
 * @param a
 * @param b
 */
// eslint-disable-next-line complexity
export function getChangedPart(a, b) {
    if (typeof a !== 'object' || typeof b !== 'object') {
        return b;
    }
    if (b === null) {
        return b;
    }
    for (const key in b) {
        if (key in a) {
            if (a[key] === b[key]) {
                deleteAttrAndOp(b, key);
            } else if (b[key] === null) {
                if (!a[key] && a[key] !== 0) {
                    deleteAttrAndOp(b, key);
                }
            } else if (Array.isArray(a[key]) && Array.isArray(b[key])) {
                if (bBelongToA(a[key], b[key])) {
                    deleteAttrAndOp(b, key);
                }
            } else if (typeof a[key] === 'object' && typeof b[key] === 'object') {
                b[key] = getChangedPart(a[key], b[key]);
                if (Object.keys(b[key]).length === 0) {
                    deleteAttrAndOp(b, key);
                }
            }
        } else if (b[key] === null || b[key] === undefined) {
            deleteAttrAndOp(b, key);
        }
    }
    return b;
}

/**
 * 深度遍历，删除所有值为Null的属性
 * @param obj
 */
export function deleteNullAttr(obj) {
    if (Array.isArray(obj)) {
        obj.forEach(e => deleteNullAttr(e));
    } else if (Object.prototype.toString.call(obj) === '[object Object]') {
        Object.keys(obj).forEach((p) => {
            if (obj[p] === null) {
                deleteAttrAndOp(obj, p);
            } else if (typeof obj[p] === 'object') {
                deleteNullAttr(obj[p]);
            }
        });
    }
}

/**
 * 删除key的同时如果op也存在的话也需要干掉，否则会出现把属性错误设置的情况
 * @param obj
 * @param attr
 */
function deleteAttrAndOp(obj, attr) {
    if (!obj || !attr) {
        return;
    }
    delete obj[attr];
    const opAttr = `${attr}Op`;
    if (obj[opAttr]?.opType !== undefined) {
        delete obj[opAttr];
    }
}
